import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import DealersTransporterDetail from './components/DealersTransporterDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageDealersTransporter',
  components: {
    DealersTransporterDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;